<template>
  <div>
    <slot name="bota-ativador" :callbackAbrirDialog="abrirDialog">
      <v-btn :disabled="disabled" color="primary" small @click="abrirDialog">
        <v-icon size="18">mdi-plus</v-icon>
        <span class="ml-1">Novo</span>
      </v-btn>
    </slot>

    <SysDialog
      v-model="dialog_ativo"
      :titulo="`${((similar_edicao === null) ? 'Novo' : 'Editando')} produto similar`"
      @click:primary="salvarProdutoSimilar()"
      @click:hidden-dialog="fecharDialog()"
    >
      <SysProdutoAutocomplete
        v-if="dialog_ativo"
        v-model="similar"
        label="Selecione o similar"
        class="mt-1"
        outlined
        return-object
        :disabled="similar_edicao !== null"
        :force-busca="[similar.id_produto]"
        :success-messages="MENSAGENS_SUCESSO"
        :error-messages="MENSAGENS_ERROS"
        :messages="MENSAGENS_INFO"
      />

      <v-checkbox
        v-model="agredar_estoque"
        color="primary"
        hide-details
        class="pb-5"
        :disabled="MENSAGENS_INFO.length > 0"
      >
        <template #label>
          <span class="ml-2">Agrupar Estoque</span>
        </template>
      </v-checkbox>
    </SysDialog>
  </div>
</template>

<script>
import SysDialog from "@/components/padraoDeLayout/SysDialog";
import SysProdutoAutocomplete from "@/components/utils/crud/SysProdutoAutocomplete";
import CompraAPI from "@/api/compra";
import {logout} from "@/helpers";
import {required} from "vuelidate/lib/validators";

export default {
  name: "NovoSimilar",
  components: {
    SysProdutoAutocomplete,
    SysDialog
  },
  props: {
    produto: Object,
    similar_edicao: {
      type: Object,
      default: null
    },
    disabled: {
      type: Boolean,
      default: true
    }
  },
  data: () => ({
    dialog_ativo: false,
    similar: {
      id_produto: '',
      idunidade_medida: '',
    },
    agredar_estoque: false
  }),
  validations: {
    similar: {
      id_produto: {
        required
      }
    }
  },
  computed: {
    MENSAGENS_SUCESSO() {
      if (!this.similar.id_produto || this.produto.idunidade_medida !== this.similar.idunidade_medida) {
        return [];
      }
      return [`Unidade de venda de ambos os produtos: ${ this.produto.idunidade_medida}`];
    },
    MENSAGENS_INFO() {
      if (!this.similar.id_produto || this.produto.idunidade_medida === this.similar.idunidade_medida) {
        return [];
      }
      return [`Não é possivel agrupar estoque, pois a unidade de venda é diferente (${this.produto.idunidade_medida} - ${this.similar.idunidade_medida}).`];
    },
    MENSAGENS_ERROS() {
      if (!this.$v.similar.id_produto.$dirty) return [];

      if (!this.$v.similar.id_produto.required) {
        return  ["Campo Obrigatório."];
      }

      return [];}
  },
  methods: {
    abrirDialog() {
      this.dialog_ativo = ! this.dialog_ativo;

      if (this.similar_edicao) {
        this.similar = {...this.similar_edicao, agredar_estoque: undefined};
        this.agredar_estoque = this.similar_edicao.agredar_estoque;
      }
    },
    fecharDialog() {
      this.dialog_ativo = false;
      this.similar.id_produto = '';
      this.similar.idunidade_medida = '';
      this.agredar_estoque = false;
      this.$v.$reset()
    },
    salvarProdutoSimilar() {
      this.$v.$touch()
      if (this.$v.$invalid) return;

      const headers = this.Helpers.iniciarRequisicao()

      const paramentos = {
        grupo: this.produto.id_grupo,
        pai: this.produto.id_produto,
        filho: [{ idproduto: this.similar.id_produto, agrupar_estoque: this.agredar_estoque }]
      };

      this.$store.dispatch(
        "loading/addRequisicao",
        CompraAPI.addSimilares(headers, paramentos)
          .then((response) => {
            const token = response.data.token
            localStorage.token = token;
            this.$emit('update:novo-similar', {});
            this.fecharDialog();
          })
          .catch(logout)
      )
    }
  }
}
</script>

<style scoped>

</style>
